"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationOp = void 0;
const HashedObject_1 = require("./HashedObject");
const HashedSet_1 = require("./HashedSet");
const OpCausalHistory_1 = require("../history/OpCausalHistory");
class MutationOp extends HashedObject_1.HashedObject {
    constructor(target) {
        super();
        this.target = target;
    }
    async validate(references) {
        if (this.target === undefined) {
            return false;
        }
        if (this.prevOps === undefined) {
            return false;
        }
        for (const prevOpRef of this.prevOps.values()) {
            let prevOp = references.get(prevOpRef.hash);
            if (prevOp === undefined) {
                return false;
            }
            else if (!(prevOp instanceof MutationOp)) {
                return false;
            }
            else if (!prevOp.target.equals(this.target)) {
                return false;
            }
        }
        return true;
    }
    getTarget() {
        return this.target;
    }
    setTarget(target) {
        this.target = target;
    }
    getPrevOps() {
        return this.prevOps.values();
    }
    getPrevOpsIfPresent() {
        if (this.prevOps === undefined) {
            return undefined;
        }
        else {
            return this.prevOps.values();
        }
    }
    setPrevOps(prevOps) {
        this.prevOps = new HashedSet_1.HashedSet(Array.from(prevOps).map((op) => op.createReference()).values());
    }
    literalizeInContext(context, path, flags) {
        if (flags === undefined) {
            flags = [];
        }
        flags.push('op');
        return super.literalizeInContext(context, path, flags);
    }
    getCausalHistory(prevOpCausalHistories) {
        return new OpCausalHistory_1.OpCausalHistory(this, prevOpCausalHistories);
    }
    getCausalHistoryProps() {
        return new Map();
    }
}
exports.MutationOp = MutationOp;
//# sourceMappingURL=MutationOp.js.map